// Utilization by Time for the Floor Deck machine categories.

// 24 hours minus a 2-hour lunch break. The server sends each company's own value;
// this is only used when the setting cannot be loaded.
export const DEFAULT_AVAILABLE_HOURS = 22;

// Operating time = planned production time - unplanned stop time: the same run
// time the daily OEE uses for Availability (0 until the first valid submission).
export function getOperatingSeconds(machine) {
    return Math.max(Number(machine && machine.availabilityRunSeconds) || 0, 0);
}

export function getTotalOperatingSeconds(machines) {
    return (machines || []).reduce((total, machine) => total + getOperatingSeconds(machine), 0);
}

// Total operating time of every machine / (machine count x scheduled available time) x 100.
export function getUtilizationByTime(machines, availableHours) {
    const list = machines || [];
    const availableSeconds = list.length * Number(availableHours) * 3600;
    if (!(availableSeconds > 0)) return 0;
    return (getTotalOperatingSeconds(list) / availableSeconds) * 100;
}
